import { render, staticRenderFns } from "./StudyRequestStatusBadge.vue?vue&type=template&id=d2f8c3ea&scoped=true&"
import script from "./StudyRequestStatusBadge.vue?vue&type=script&lang=js&"
export * from "./StudyRequestStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./StudyRequestStatusBadge.vue?vue&type=style&index=0&id=d2f8c3ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f8c3ea",
  null
  
)

export default component.exports